import React from 'react'

import {
  Box,
  Typography,
  TextField,
  Checkbox,
  FormControl,
  FormGroup,
  FormControlLabel
} from '@material-ui/core'

const ImagePicker: React.FC<{
  value: string
  checked: boolean
  inputHandler: (input: string) => void
  checkHandler: (checked: boolean) => void
}> = ({ inputHandler, checkHandler, value, checked }) => {
  return (
    <React.Fragment>
      <Box>
        <Typography variant="body2" paragraph>
          ※「外部リンク設定」にURLを入力すると、指定したURLに外部リンクすることができます。
        </Typography>
        <Typography variant="body2" paragraph>
          ※この設定を行うと、「ファイルリンク設定」、「文字情報」の設定内容は無効になります。
        </Typography>
        <Box mb={7}>
          <TextField
            id="input-external-link"
            label="URLを入力"
            value={value}
            variant="outlined"
            fullWidth
            margin="normal"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              inputHandler(event.target.value)
            }
            InputProps={{ labelWidth: 120 }}
          />
          {checked !== null && (
            <FormControl component="fieldset" style={{ marginLeft: '1rem' }}>
              <FormGroup aria-label="position" row>
                <FormControlLabel
                  value="top"
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) =>
                        checkHandler(event.target.checked)
                      }
                    />
                  }
                  label={
                    <span>
                      会員のシームレスログインを許可する
                      <br />
                      ※指定するURLが会員認証を必要とするサイトの場合、会員はシームレスにログインすることができます。
                    </span>
                  }
                  labelPlacement="end"
                />
              </FormGroup>
            </FormControl>
          )}
        </Box>
      </Box>
    </React.Fragment>
  )
}

export default ImagePicker
